import { SWITCH_ACTIVE_GAUGE } from './types'

export function doActivateGauge(instanceId, activeGauge) {
  return {
    type: SWITCH_ACTIVE_GAUGE,
    payload: { activeGauge, instanceId },
  }
}
